import * as React from 'react';
import classnames from 'classnames';

var FormActions = function FormActions(_ref) {
  var className = _ref.className,
      children = _ref.children;

  var _className = classnames(className, 'FormActions');

  return React.createElement("div", {
    className: _className
  }, children);
};

FormActions.defaultProps = {
  className: undefined
};
FormActions.displayName = 'Form.Actions';
export default FormActions;